import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ListaCursos from './components/ListaCurso';
import EstudoCurso from './components/meuscursos/EstudoCurso';
import ModuloCurso from './components/meuscursos/ModuloCurso';
import About from './components/About';
import Vantagens from './components/Vantagens';
import CertificadosPage from './components/CertificadosPage';
import Cursos from './components/Cursos';
import Contatos from './components/Contatos';
import Login from './components/Login';
import Cadastro from './components/Cadastro';
import RecuperacaoSenha from './components/RecuperacaoSenha';
import MeusCursos from './components/meuscursos/MeusCursos';
import MeusCertificados from './components/meuscursos/MeusCertificados';
import MeusDados from './components/meuscursos/MeusDados';
import ProtectedRoute from './components/ProtectedRoute';
import Prova from './components/meuscursos/Prova';
import Carrinho from './components/meuscursos/Carrinho';
import ModuloEditor from './components/meuscursos/ModuloEditor';
import CadastroCurso from './components/admin/CadastroCurso';
import CadastroModulos from './components/admin/CadastroModulos';
import ExamManagementPage from './components/admin/ExamManagementPage';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminAnalyticsDashboard from './components/admin/AdminAnalyticsDashboard';
import AdminUsageInsights from './components/admin/AdminUsageInsights';
import AdminUserProfile from './components/admin/AdminUserProfile';
import ResumeBuilder from './components/admin/ResumeBuilder';
import AnalyticsTracker from './components/AnalyticsTracker';
import VerificarCertificado from './components/VerificarCertificado';
import InformationalPage from './components/InformationalPage';
import SearchResults from './components/SearchResults';
import CatalogoSlug from './components/catalogo/CatalogoSlug';
import LegacyCursoRedirect from './components/catalogo/LegacyCursoRedirect';
import ScrollToTop from './components/ScrollToTop';
import { NotificationProvider } from './components/NotificationSystem';
import { LoadingProvider } from './components/LoadingProvider';

import './styles/Global.css';
import './styles/QuillAlignment.css';

import './App.css';
import './styles/BrandRefresh.css';
import './styles/BrandSurfaces.css';

function App() {
  return (
    <NotificationProvider>
      <LoadingProvider>
        <Router>
          <AnalyticsTracker />
          <ScrollToTop />
          <div className="App">
            <Header />
            <Routes>
              <Route path="/" element={<ListaCursos />} />
              <Route path="/sobre-a-abraliber" element={<About />} />
              <Route path="/vantagens" element={<Vantagens />} />
              <Route path="/certificados" element={<CertificadosPage />} />
              <Route path="/certificados/:id" element={<CertificadosPage />} />
              <Route path="/cursos" element={<Cursos />} />
              <Route path="/cursos/:slug" element={<CatalogoSlug />} />
              <Route path="/buscar" element={<SearchResults />} />
              <Route path="/curso/:id" element={<LegacyCursoRedirect />} />
              <Route path="/curso/:id/estudo" element={<EstudoCurso />} />
              <Route path="/curso/:cursoId/modulo/:moduloId" element={<ModuloCurso />} />
              <Route path="/contato" element={<Contatos />} />
              <Route path="/ajuda" element={<InformationalPage pageKey="ajuda" />} />
              <Route path="/perguntas-frequentes" element={<InformationalPage pageKey="faq" />} />
              <Route path="/politica-de-privacidade" element={<InformationalPage pageKey="privacidade" />} />
              <Route path="/termos-de-uso" element={<InformationalPage pageKey="termos" />} />
              <Route path="/acessibilidade" element={<InformationalPage pageKey="acessibilidade" />} />
              <Route path="/login" element={<Login />} />
              <Route path="/cadastro" element={<Cadastro />} />
              <Route path="/recuperacao-senha" element={<RecuperacaoSenha />} />
              <Route path="/verificar-certificado" element={<VerificarCertificado />} />
              <Route path="/meus-cursos" 
                element={
                  <ProtectedRoute>
                    <MeusCursos />
                  </ProtectedRoute>
                } 
              />
              <Route path="/curso/:cursoId/modulo/novo" element={<ModuloEditor />} />
              <Route path="/curso/:cursoId/modulo/:moduloId" element={<ModuloEditor />} />   
              <Route path="/curso/:id/prova" element={<ProtectedRoute><Prova /></ProtectedRoute>} />
              <Route path="/cart/add" element={<ProtectedRoute><Carrinho /></ProtectedRoute>} />
              <Route path="/meus-dados"
                element={
                  <ProtectedRoute>
                    <MeusDados />
                  </ProtectedRoute>
                }
              />
              <Route path="/meus-certificados" 
                element={
                  <ProtectedRoute>
                    <MeusCertificados />
                  </ProtectedRoute>
                } 
              />
              
              {/* Rotas Administrativas */}
              <Route path="/admin" 
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route path="/admin/usuarios/:userId"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminUserProfile />
                  </ProtectedRoute>
                }
              />
              <Route path="/admin/analytics"
                element={
                  <ProtectedRoute>
                    <AdminAnalyticsDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="/admin/percepcao-de-uso"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminUsageInsights />
                  </ProtectedRoute>
                }
              />
              <Route path="/admin/curriculo"
                element={
                  <ProtectedRoute requireAdmin>
                    <ResumeBuilder />
                  </ProtectedRoute>
                }
              />
              <Route path="/curriculo"
                element={
                  <ProtectedRoute>
                    <ResumeBuilder />
                  </ProtectedRoute>
                }
              />
              <Route path="/admin/cursos/novo" 
                element={
                  <ProtectedRoute>
                    <CadastroCurso />
                  </ProtectedRoute>
                } 
              />
              <Route path="/admin/cursos/:cursoId/modulos" 
                element={
                  <ProtectedRoute>
                    <CadastroModulos />
                  </ProtectedRoute>
                } 
              />
              <Route path="/admin/cursos/:cursoId/exames" 
                element={
                  <ProtectedRoute>
                    <ExamManagementPage />
                  </ProtectedRoute>
                } 
              />
            </Routes>
            <Footer />
          </div>
        </Router>
      </LoadingProvider>
    </NotificationProvider>
  );
}

export default App;
